<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      class="mb-6"
      v-model="form.stdInfo"
      :board="this.board"
      :date-readonly="false"
      :is-print="isPrint" />


    <!-- 안전보건 협의체 협의회 운영 -->
    <div class="mb-5">
      <h5 class="mb-5"><i class="dot"></i> 안전보건 협의체 협의회 운영</h5>
      <div class="writeGridContainer">
        <div class="writeGridCol2">
          <div>대상사업</div>
          <ml-input v-model="form.대상사업" />
        </div>
        <div></div>
        <div>
          <div>업체명</div>
          <ml-input v-model="form.업체명" />
        </div>
        <div>
          <div>일시</div>
          <ml-input v-model="form.일시" />
        </div>
        <div>
          <div>장소</div>
          <ml-input v-model="form.장소" />
        </div>
        <div>
          <div>회의록</div>
          <file-uploader v-model="form.회의록"/>
        </div>
      </div>
    </div>


    <!--파일첨부-->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" class="mt-28px" :is-print="isPrint" />

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploader from "@/components/FileUploader.vue";
import FileDownload from "@/components/FileDownload.vue";

export default {
  components: {
    FileDownload,
    FileUploader,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        "대상사업": "",
        "업체명": "",
        "일시": "",
        "장소": "",
        "회의록": undefined,
      },
    };
  },
  methods: {
    onSelectFieldSelector (value) {
      this.form.학교명 = value.field_name;
    }
  },
};
</script>

<style scoped lang="scss">
</style>
